import { Icon } from '@iconify/react'
import { maskBrazilianPhone } from '@/lib/person-data/mask-brazilian-phone'
import { buildWhatsAppChatHref } from '@/lib/whatsapp-link'
import styles from './PhoneWhatsAppLink.module.css'

export interface PhoneWhatsAppLinkProps {
  phone: string | null | undefined
  contactName?: string
  className?: string
}

export function PhoneWhatsAppLink({ phone, contactName, className }: PhoneWhatsAppLinkProps) {
  const raw = phone?.trim() ?? ''

  if (!raw) {
    return <span className={styles.empty}>—</span>
  }

  const display = maskBrazilianPhone(raw) || raw
  const href = buildWhatsAppChatHref(raw)
  const linkClassName = className ? `${styles.link} ${className}` : styles.link

  if (!href) {
    return <span className={styles.plain}>{display}</span>
  }

  const ariaLabel = contactName
    ? `Chamar ${contactName} no WhatsApp`
    : `Abrir conversa no WhatsApp para ${display}`

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={linkClassName}
      aria-label={ariaLabel}
    >
      {display}
      <Icon icon="mdi:whatsapp" className={styles.icon} aria-hidden />
    </a>
  )
}
